import groupby from 'lodash.groupby';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

import { selectDocumentSetId } from 'services/documentSets/selectors';
import { selectDocumentsArray } from 'services/documents/selectors';
import { DocumentAttribute } from 'services/documents/types';
// @ts-ignore
import { selectSchemaAttribute } from 'services/schemaAttributes/selectors';

// @ts-ignore
import {
    averageInteger,
    averageFloat,
    joinValues,
    averageBoolean
} from 'utils/document-attribute';

const selectDocumentAttributes = createDeepEqualSelector(
    [selectDocumentsArray, selectDocumentSetId],
    (documents, documentSetId) => {
        const documentAttributes = documents.reduce((result, doc) => {
            if (doc.documentSetId !== documentSetId) return result;
            return result.concat(doc.documentAttributes);
        }, [] as DocumentAttribute[]);

        return groupby(documentAttributes, 'schemaAttributeId');
    }
);

const selectAttributeValue = createDeepEqualSelector(
    [selectDocumentAttributes, selectSchemaAttribute],
    (documentAttributes, schemaAttribute: any) => {
        const { id, dataTypeId, disabledAvg } = schemaAttribute;
        let value;

        if (!documentAttributes[id]) return value;

        if (dataTypeId === 'INTEGER') {
            const values = documentAttributes[id].map(
                (docAttribute) => docAttribute.integerValue || 0
            );

            value = disabledAvg ? joinValues(values) : averageInteger(values);
        } else if (dataTypeId === 'FLOAT') {
            const values = documentAttributes[id].map(
                (docAttribute) => docAttribute.floatValue || 0
            );

            value = disabledAvg ? joinValues(values) : averageFloat(values);
        } else if (dataTypeId === 'BOOLEAN') {
            const values = documentAttributes[id].map(
                (docAttribute) => docAttribute.booleanValue || false
            );

            value = averageBoolean(values);
        } else if (dataTypeId === 'STRING') {
            const values = documentAttributes[id].map(
                (docAttribute) => docAttribute.stringValue || ''
            );

            value = joinValues(values);
        }

        return value;
    }
);

export const makeSelectAttributeValue = (): typeof selectAttributeValue =>
    selectAttributeValue;
